import { ColumnEditorOptions, ColumnHeaderOptions } from "primereact/column";
import { translate } from "../common";
import { DataTableFilterMeta } from "primereact/datatable";

import { MenuItem } from "primereact/menuitem";

export type SortOrder = 1 | 0 | -1 | null | undefined;

export interface LazyOptions {
    sortOrder?: SortOrder ;
    sortField?: string;
    filters?: DataTableFilterMeta;
    first?: number;
    rows?: number;
    page?: number;
}


export interface DataColumn {
    id: string;
    field: string;
    type: string;
    header: string;
    key: string;
    editor?: (options: ColumnEditorOptions) => JSX.Element;
    body?: (field: string, rowData: any) => JSX.Element | string;

}

export interface HeaderAction extends MenuItem {
    path?: string;
    roles?: string[];
    items?: HeaderAction[];
}


export const gridCurrentPageReportTemplate = () => { return "{first} " + translate("PAGINATION_TO") + " {last} " + translate("PAGINATION_OF") +  " {totalRecords}"}
export const dataViewPaginatorTemplate = "({currentPage} of {totalPages})"
export const paginatorTemplate = "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
export const paginationRows = [5, 10, 20, 30, 50, 100]
export const largePaginationRows = [100, 200, 500, 1000, 2000, 5000, 10000]